export default __webpack_public_path__ + "static/media/e3.fce7f9a1.jpg";